module.exports = __webpack_public_path__ + "static/media/icons-home-garden.51cb32c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/icons-home-garden.svg
// module id = 790
// module chunks = 0